<template>
  <div class="repairman backdrop">
    <div class="common repairman-search">
      <input type="text" v-model="search_input"  placeholder="请输入姓名" @keyup.enter="search" @input="search($event)" />
      <img class="search-close" src="../../assets/images/repairman-search-close.png" @click="clean()">
      <div>搜索</div>
    </div>
    <div class="common repairman-list" v-for="(r_keeper, r_keeper_key) in repair_keeper_list" :key="r_keeper_key" @click="selectpust(r_keeper.id, r_keeper.village_member_name, r_keeper.tel, r_keeper.head_portrait,id, village_member_name, tel, head_portrait)">
      <div class="repairman-list-block" style="background-color:#ccc" v-if="id==r_keeper.id">

        <img class="selectimg" src="../../assets/images/repairman-select.png">
        <img class="headimg" :src="r_keeper.head_portrait">
        <div class="message">
          <span>{{r_keeper.village_member_name}}{{r_keeper.tel}}</span>
          <span>{{r_keeper.tel}}</span>
        </div>
        <div class="singular"><span>{{r_keeper.num}}</span>单</div>
      </div>
      <div class="repairman-list-block" v-else>
        <img class="selectimg" src="../../assets/images/repairman-select.png">
          <img class="headimg" :src="r_keeper.head_portrait">
          <div class="message">
            <span>{{r_keeper.village_member_name}}{{r_keeper.tel}}</span>
            <span>{{r_keeper.tel}}</span>
          </div>
          <div class="singular"><span>{{r_keeper.num}}</span>单</div>
        </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'SelectRepairman',
  metaInfo: {
    title: '选择维修师傅'
  },
  data () {
    return {
      repair_keeper_list: [],
      name: 'search',
      search_list: [],
      jsonarray: [],
      newarray: [],
      index: 0,
      search_input: ''
    }
  },
  computed: {
    ...mapState(['villageId'])
  },
  created () {
    this.getRepairKeeper()
    this.id = this.$route.query.id
    this.village_member_name = this.$route.query.name
    this.tel = this.$route.query.tel
    this.head_portrait = this.$route.query.head_portrait
    this.member = this.$route.query.member
  },
  methods: {
    getRepairKeeper () {
      this.axios.get('/wechat/repair/getRepairKeeper/village_id/' + this.villageId)
        .then((res) => {
          if (res.data.status === 1) {
            this.repair_keeper_list = res.data.data
            this.search_list = res.data.data
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    selectpust: function (id, name, tel, headportrait, zid, zname, ztel, zheadportrait) {
      // this.x = JSON.stringify(this.jsonarray)
      // this.b = JSON.parse(this.x)
      // this.x = JSON.stringify(this.jsonarray)
      // this.b.push(JSON.parse(this.member))
      this.jsonarray = [{
        id: id,
        village_member_name: name,
        tel: tel,
        head_portrait: headportrait
      }]

      this.newarray = JSON.parse(this.member).concat(this.jsonarray)
      this.newarray = this.unique(this.newarray)
      if (id !== this.id) { this.$router.push({name: 'Repairman', query: {newarray: JSON.stringify(this.newarray), id: zid, name: zname, tel: ztel, head_portrait: zheadportrait}}) }
      // console.log(JSON.parse(this.member))
    },
    have: function (currentPositionInfo, id) {
      currentPositionInfo.some(function (item) {
        if (item.id === id) {
          return false
        } else {
          return true
        }
      })
    },
    unique: function (arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
    },
    fuzzyMatch: function (str, key) {
      let index = -1
      let flag = false
      for (var i = 0, arr = key.split(''); i < arr.length; i++) {
        // 有一个关键字都没匹配到，则没有匹配到数据
        if (str.indexOf(arr[i]) < 0) {
          break
        } else {
          let match = str.matchAll(arr[i])
          let next = match.next()
          while (!next.done) {
            if (next.value.index > index) {
              index = next.value.index
              if (i === arr.length - 1) {
                flag = true
              }
              break
            }
            next = match.next()
          }
        }
      }
      console.log(flag)
      return flag
    },
    search: function (event) {
      if (event.currentTarget.value.length === 0) {
        this.repair_keeper_list = this.search_list
      } else {
        this.repair_keeper_list = []
        for (let i = 0; i < this.search_list.length; i++) {
          if (this.fuzzyMatch(this.search_list[i].village_member_name, event.currentTarget.value)) {
            this.repair_keeper_list.splice(i, 0, this.search_list[i])
          }
        }
      }
    },
    clean: function () {
      this.search_input = ''
      this.repair_keeper_list = this.search_list
    }

    // 选择维修师傅
    // selectRepairman: function (id, name, tel, permission) {
    //   this.$router.push({name: 'Repairman', query: {id: id, name: name, tel: tel, permission: permission}})
    // }
  }
}
</script>
<style scoped>
.repairman-search {
  display: flex;
  position: relative;
}
.repairman-search input {
  flex: 1;
  height: 27px;
  background-color: #f8f8f8;
  border-radius: 14px;
  border: none;
  padding: 0 28px 0 30px;
  background-image: url(../../assets/images/repairman-search.png);
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: 9px center;
  outline: none;
}
.repairman-search div {
  font-size: 14px;
  color: #000000;
  padding-left: 20px;
  line-height: 27px;
}
.repairman-search img {
  width: 16px;
  height: 16px;
  position: absolute;
  top: 20px;
  right: 72px;
}
.repairman-list {
  padding: 5px 15px;
}
.repairman-list .repairman-list-block {
  display: flex;
  padding: 10px 0;
}
.repairman-list .repairman-list-block .message {
  flex: 1;
  color: #000000;
  padding: 0 15px;
}
.repairman-list .repairman-list-block .message span {
  display: block;
}
.repairman-list .repairman-list-block .message span:first-child {
  font-size: 15px;
  padding-top: 9px;
}
.repairman-list .repairman-list-block .message span:last-child {
  font-size: 12px;
  color: #8c8c8c;
  padding-top: 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
}
.repairman-list .repairman-list-block .headimg {
  width: 59px;
  height: 59px;
  border-radius: 50%;
}
.repairman-list .repairman-list-block .selectimg {
  width: 23px;
  height: 23px;
  margin: 18px 15px 0 0;
}
.repairman-list .singular {
  font-size: 15px;
  line-height: 59px;
}
.repairman-list .singular span {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Repair/CheckRepairman.vue